import React from "react";
import { Spinner } from "cakemail-ui-components/lib/react";
import PropTypes from "prop-types";
import classNames from "classnames";

export const SpinnerContainer = (props) => {
	let classes = classNames("spinnerContainer", {
		pageCenter: props.contentCenter === false ? props.pageCenter : false,
		contentCenter: props.contentCenter,
	});
	return (
		<div className={classes}>
			<Spinner radius={70} strokeWidth={2} spinnerSpeed={1} />
		</div>
	);
};
SpinnerContainer.propTypes = {
	contentCenter: PropTypes.bool,
	pageCenter: PropTypes.bool,
};

SpinnerContainer.defaultProps = {
	contentCenter: true,
	pageCenter: false,
};
export default SpinnerContainer;
